import templateUrl from './preterminate-revert-confirmation.template.html';
import nxModule from 'nxModule';
import {ModalApi} from "components/technical/modal/modal.component";

export interface Api {
  show: () => Promise<{
      confirmed: boolean,
      remarks?: string
  }>
}

class PreterminateRevertConfirmation {
  remarks: string = '';
  onPreterminateRevertConfirmationReady!: (api: Api) => void;
  onModalApiReady = ({api,}: {api: ModalApi}): void => {
    this.onPreterminateRevertConfirmationReady({
      show: async () => {
        this.remarks = '';
        const {accepted} = await api.show();

        return {
          confirmed: accepted,
          remarks: this.remarks
        }
      }
    });
  }
}

nxModule.component('preterminateRevertConfirmation', {
  templateUrl,
  bindings: {
    onPreterminateRevertConfirmationReady: '<',
  },
  controller: PreterminateRevertConfirmation
});